import { useState } from 'react';
import useWhyBuyNarratives from '~/hooks/vdp/selectors/useWhyBuyNarratives';
import useCarouselAnalytics from '~/hooks/vdp/useCarouselAnalytics';
import PageCountCarousel from './PageCountCarousel/PageCountCarousel';
import WhyBuyWithImageryCard from './WhyBuyWithImageryCard';

export default function ExperimentWhyBuyCarousel() {
  const narratives = useWhyBuyNarratives();
  const handleAnalytics = useCarouselAnalytics();
  const [activeCardId, setActiveCardId] = useState<string | null>(null);

  return narratives.length > 0 ? (
    <PageCountCarousel
      ariaLabel="features you'll love"
      testId="why-buy-carousel"
      trackEvent={event => {
        handleAnalytics({ event });
      }}
    >
      {narratives.map(narrative => (
        <WhyBuyWithImageryCard
          bulletPoint={narrative}
          isActive={activeCardId === narrative.id}
          key={narrative.id}
          onActivate={() => setActiveCardId(narrative.id)}
        />
      ))}
    </PageCountCarousel>
  ) : null;
}
